import { component } from 'picoapp';

export default component(async (node) => {
  const toggle = node.querySelector('[data-toggle]');
  const cancel = node.querySelector('[data-cancel]');
  const deleteButton = node.querySelector('[data-delete]');
  const formContainer = node.querySelector('[data-form-container]');
  const form = formContainer.querySelector('form');
  const country = form.querySelector('[name="address[country]"]');
  const province = form.querySelector('[name="address[province]"]');

  toggle.addEventListener('click', () => {
    formContainer.hidden = !formContainer.hidden;
  });

  cancel.addEventListener('click', () => {
    formContainer.hidden = true;
  });

  if (deleteButton) {
    deleteButton.addEventListener('click', () => {
      Shopify.postLink(deleteButton.dataset.target, {
        parameters: { _method: 'delete' },
      });
    });
  }

  const initCountry = () =>
    new Shopify.CountryProvinceSelector(country.id, province.id, {
      hideElement: province.parentElement.id,
    });
  initCountry();
});
